import BreadcrumbsComponent from '@components/v2/Breadcrumbs';
import { Link, useRouterState } from '@tanstack/react-router';
import { Text } from '@huspy/briks-web';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const Breadcrumbs = () => {
  const { t } = useTranslation();
  const matchingRoutes = useRouterState({ select: (r) => r.matches })
    .filter(
      (route) => route.routeContext && 'breadcrumb' in route.routeContext && route.routeContext.breadcrumb
    );

  const breadcrumbItems = useMemo(() => matchingRoutes.map((match, i) => (
    <Link
      to={ match.pathname }
      key={ match.id }
      style={ { width: '100%' } }
    >
      <Text
        color={ matchingRoutes.length - 1 === i ? 'text-primary' : 'text-secondary' }
        size='md'
        fontWeight={ matchingRoutes.length - 1 === i ? 'semibold' : 'regular' }
      >
        {t(`common.breadcrumbs.${match.context!.breadcrumb!.key}.title`)}
      </Text>
    </Link>
  )), [matchingRoutes, t]);
  return (
    <BreadcrumbsComponent>{breadcrumbItems}</BreadcrumbsComponent>
  );
};
